import React, { useState, useRef, useEffect } from "react";
import Header from "../../layouts/Header";
import logo from "../../assets/icons/SpireLogo.png";
import download from "../../assets/icons/share.svg";
import { FaPen } from "react-icons/fa";
import calender from "../../assets/images/Calendar3.svg";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw } from "draft-js";
import "draft-js/dist/Draft.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useParams } from "react-router-dom";
import ReactSignatureCanvas from "react-signature-canvas";
import { TfiPencilAlt2 } from "react-icons/tfi";
import { RiEraserFill } from "react-icons/ri";
import simpleRequest from "../../utils/helpers/simpleRequest";
import moment from "moment";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import generatePDF from "react-to-pdf";

const QuotePdfNew = () => {
  const { quoteId } = useParams();
  const pdfRef = useRef(null);
  const HIGH = process.env.REACT_APP_QUOTE_PRIORITY_HIGH;
  const MEDIUM = process.env.REACT_APP_QUOTE_PRIORITY_MEDIUM;
  const LOW = process.env.REACT_APP_QUOTE_PRIORITY_LOW;
  const [activeTab, setActiveTab] = useState("General");
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [typing, setTyping] = useState(false);
  const refSignatureContainer = useRef(null);
  const [quote, setQuote] = useState(null);
  const signRef = useRef(null);
  const [hasSignature, setHasSignature] = useState(false);
  const [sections, setSections] = useState([]);
  const [quoteDetails, setQuoteDetails] = useState({
    quoteCode: "",
    status: "",
    projectName: "",
    projectCode: "",
    projectId: "",
    quoteDate: "",
    mainContact: "",
    reference: "",
    priorityId: HIGH,
  });

  const handleUseEraser = () => {
    let canvas = document.getElementById("quote-signature-canvas");
    let context = canvas.getContext("2d");
    context.globalCompositeOperation = "destination-out";
    context.strokeStyle = "rgba(239, 239, 239, 1)";
    context.lineWidth = 15;
  };

  const handleDraw = () => {
    let canvas = document.getElementById("quote-signature-canvas");
    let context = canvas.getContext("2d");
    context.globalCompositeOperation = "source-over";
    context.lineWidth = 15;
  };

  const clearCanvas = () => {
    signRef.current?.clear();
    setHasSignature(false);
  };

  const onSignEnd = () => {
    setHasSignature(true);
  };

  const changeApplied = (e) => {
    setEditorState(e);
    setTyping(true);
  };

  const scrollToSignatureContainer = () => {
    if (refSignatureContainer.current) {
      refSignatureContainer.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const fetchQuote = async () => {
    const resp = await simpleRequest(`/api/quote/${quoteId}`, "get", {});
    if (resp?.status === true) {
      const { data } = resp;
      setQuoteDetails({
        quoteCode: data?.quotecode,
        status: data?.status,
        quoteDate: new Date(data?.quoteDate || new Date()),
        projectCode: data?.projectcode,
        projectId: data?.projectid,
        projectName: data?.projectname,
        mainContact: data?.maincontact,
        reference: data?.reference,
        priorityId: data?.priorityid,
      });
      const sectionsList = [...data?.sections];
      let list = [];
      sectionsList?.map((section) => {
        let subSections = [];
        section?.subSections?.map((subSection) => {
          let sub = {
            ...subSection,
            description: EditorState.createWithContent(
              convertFromRaw(JSON.parse(subSection?.description))
            ),
          };
          subSections.push(sub);
        });
        list.push({ ...section, subSections });
      });
      setSections([...list]);
    }
  };

  const handlePrintPdf = () => {
    generatePDF(pdfRef, { filename: "page.pdf" });
  };

  useEffect(() => {
    fetchQuote();
  }, []);

  return (
    <>
      <Header />
      <div className="quote-n-id-box" style={{ padding: "0" }}>
        <div
          className="quote-n-topbox frcb"
          style={{ alignItems: "start", padding: "0 36.35px 24px 26.58px" }}
        >
          <img src={logo} className="signLogoImage" />
          <div className="frc" style={{ gap: "1rem" }}>
            <button className="cal-page-cancel">Cancel</button>
            <button className="cal-page-change" style={{ backgroundColor: "#00246A" }}>
              Send
            </button>
          </div>
        </div>
        <div className="quote-n-pdf-blue-bg-main frc">
          <div role="button" className="quote-n-pdf-btn frc">
            <p className="mb-0">Send</p>
            <FaPen style={{ fontSize: "0.8rem" }} />
          </div>
          <div role="button" className="quote-n-pdf-btn frc" onClick={handlePrintPdf}>
            <p className="mb-0">Download</p>
            <img src={download} width={18} height={20} />
          </div>
        </div>
        <div ref={pdfRef} style={{ margin: "0 auto", maxWidth: "95%", backgroundColor: "#fafafa" }}>
          <div className="quote-n-pdf-content-box" style={{ maxWidth: "95%", margin: "0 auto" }}>
            <p className="quote-n-pdf-content-main-heading">Commercial Proposal</p>
            <div className="quote-n-pdf-content-para fc" style={{ rowGap: "2rem" }}>
              <p>This document is an official quotation for client's review and approval.</p>
              <p>
                Outlined in the document is a detailed breakdown of expenses encompassing labor,
                materials, and associated costs required for the successful completion of the
                project/milestone of a project.
              </p>
              <p>
                In confirming your acceptance of the quote, your signature on this document
                signifies acknowledgment and agreement to all outlined expenses. To facilitate a
                smooth progression of the project, we kindly request that you sign and send
                digitally a document at the nearest time.
              </p>
            </div>
          </div>
          <div className="frcb quote-n-box-tab-prob" style={{ padding: "0" }}>
            <div style={{ overflow: "auto", width: "100%" }}>
              <div className="frc" style={{ columnGap: "1.5rem", minWidth: "500px" }}>
                <div
                  className={`fc single-box ${activeTab === "General" && "active"}`}
                  onClick={() => setActiveTab("General")}
                >
                  General
                </div>
                <div
                  className={`fc single-box ${activeTab === "Other Conditions" && "active"}`}
                  onClick={() => setActiveTab("Other Conditions")}
                >
                  Other <br /> Conditions
                </div>
                <div
                  className={`fc single-box ${activeTab === "Points of attention" && "active"}`}
                  onClick={() => setActiveTab("Points of attention")}
                >
                  Points of <br /> attention
                </div>
                <div
                  className={`fc single-box ${activeTab === "Appendix" && "active"}`}
                  onClick={() => setActiveTab("Appendix")}
                >
                  Appendix
                </div>
              </div>
            </div>
          </div>
          <div className="quote-n-sections-main" style={{ marginTop: "0" }}>
            {activeTab === "General" && (
              <div className="quote-n-sections-main-1" style={{ padding: "2rem" }}>
                <div className="st-single-stage-div">
                  <p className="st-single-stage-label">Date</p>
                  <section className="frc" style={{ columnGap: "8px" }}>
                    <img src={calender} />
                    <p className="quote-n-contact-text">
                      {moment.utc(new Date(quoteDetails?.quoteDate)).format("DD.MM.yyyy")}
                    </p>
                  </section>
                </div>
                <div className="st-single-stage-div">
                  <label className="st-single-stage-label">Project</label>
                  <p className="quote-n-project-text">
                    {quoteDetails?.projectCode} | {quoteDetails?.projectName}
                  </p>
                </div>
                <div className="st-single-stage-div">
                  <label className="st-single-stage-label">Main Contact</label>
                  <p className="quote-n-contact-text">{quoteDetails?.mainContact}</p>
                </div>
                <div className="st-single-stage-div">
                  <label className="st-single-stage-label">Reference</label>
                  <p className="quote-n-contact-text">{quoteDetails?.reference}</p>
                </div>
              </div>
            )}
            <div className="quote-n-sections-main-2">
              <div className="fc" style={{ rowGap: "1rem", width: "100%" }}>
                {sections
                  ?.find((item) => item?.sectionName === activeTab)
                  ?.subSections?.map((subSection, index) => {
                    return (
                      <SingleSubSection
                        key={index}
                        title={subSection?.title}
                        description={subSection?.description}
                        subSectionParts={subSection?.subSectionParts}
                        subSection={subSection}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
          <div
            className="quote-signature-container"
            ref={refSignatureContainer}
            style={{ width: "80%", margin: "3rem auto" }}
          >
            <div className="quote-signature-label">Signature</div>
            <div className="d-flex align-items-center justify-content-center">
              <div className="position-relative">
                {!quote?.isSigned && (
                  <>
                    <ReactSignatureCanvas
                      ref={signRef}
                      backgroundColor="#d7d7d74a"
                      onEnd={onSignEnd}
                      canvasProps={{
                        width: quote?.isSigned ? 0 : 754,
                        height: quote?.isSigned ? 0 : 291,
                        id: "quote-signature-canvas",
                      }}
                    />
                    <div className="signature-clear-button" onClick={clearCanvas}>
                      Clear
                    </div>
                    <div className="signature-pen-button">
                      <TfiPencilAlt2
                        color="#7E7E7E"
                        size={18}
                        fill="#7E7E7E"
                        onClick={() => handleDraw()}
                      />
                    </div>
                    <div className="signature-eraser-button" onClick={handleUseEraser}>
                      <RiEraserFill color="#7E7E7E" size={18} />
                    </div>
                  </>
                )}
                {quote?.isSigned && (
                  <img src={quote.signature} height={291} width={754} className="signature-image" />
                )}
                <div className="signature-horizontal-line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const SingleSubSection = ({ title, description, subSectionParts, subSection }) => {
  const [editorState, setEditorState] = useState(description);
  const [typing, setTyping] = useState(false);

  const textEnd = { textAlign: "end" };

  const changeApplied = (e) => {
    setEditorState(e);
    setTyping(true);
  };

  return (
    <div className="quote-n-single-section frc">
      <div className="quote-n-single-section-main fc">
        <div className="quote-n-single-section-head frcb" style={{ columnGap: "1rem" }}>
          <p className="quote-n-single-section-title-input">{title}</p>
          {subSection?.totalizeAmountInSectionHeader === 1 && (
            <p className="quote-n-subSection-total">
              {europeanFormatWithSymbol(subSection?.total)}
            </p>
          )}
        </div>
        <div>
          {subSectionParts?.length > 0 && (
            <div className="quote-n-subsection-prod-main-box fc">
              <div className="quote-n-subsection-prod-topbox">
                <p>Item Description</p>
                <p style={{ textAlign: "center" }}>Measure Unit</p>
                <p style={textEnd}>Unit Price</p>
                <p style={textEnd}>Qty.</p>
                <p style={textEnd}>Total</p>
              </div>
              <div className="quote-n-subsection-underline-dashed" />
              <div className="fc" style={{ rowGap: "0.5rem", padding: "0.5rem 1rem" }}>
                {subSectionParts?.map((part, i) => {
                  return (
                    <div className="quote-n-subsection-prod-single" key={i}>
                      <p>{part?.productPartName}</p>
                      <p style={{ textAlign: "center" }}>{part?.measureUnit}</p>
                      <p style={textEnd}>{europeanFormatWithSymbol(+part?.unitPrice)}</p>
                      <p style={textEnd}>{part?.qty}</p>
                      <p style={textEnd}>{europeanFormatWithSymbol(+part?.total)}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div className="quote-n-editor-div">
            <Editor
              placeholder=""
              editorState={editorState}
              readOnly={true}
              onEditorStateChange={changeApplied}
              wrapperClassName="wrapper-class"
              editorClassName="write-message"
              toolbarClassName="toolbar-dis-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotePdfNew;
